export default "/img/MK.c80b6959d8cabd976721a5d915a72f3d.png";